import { ErrorState, SkeletonText } from "@flexfreight/ui";
import type { UseQueryResult } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { ApiError } from "../../api/client";

/**
 * The body every integration Section shares: skeleton lines while the settings load, the error with a retry in
 * place, then the card's facts and controls, and one line for roles that can only look.
 */
export function IntegrationBody({ q, canManage, children }: { q: Pick<UseQueryResult<unknown>, "isPending" | "isError" | "error" | "refetch" | "data">; canManage: boolean; children: ReactNode }) {
  if (q.isError && !q.data) {
    return <ErrorState compact title="Couldn't load this integration" message={q.error instanceof ApiError ? q.error.message : undefined} onRetry={() => void q.refetch()} />;
  }
  if (q.isPending) {
    return (
      <div aria-busy="true">
        <SkeletonText lines={3} />
        <span className="ffx-sr">Loading…</span>
      </div>
    );
  }
  return (
    <>
      {children}
      {canManage ? null : <p className="ffa-muted ffa-small">Only owners and admins can change integrations.</p>}
    </>
  );
}
